import React, { useMemo, useState } from 'react';
import { useI18n } from '../../contexts/I18nContext';
import { fmtInTz } from '../../lib/tz';
import { lastNights } from '../../lib/movementView';
import { VerdictDot, VERDICT_NAME, nightSentence } from './nightVerdict';

// 7 tappable dots, oldest → newest; the sentence below describes the selected night.
export function NightDots({ buckets, ids, policy, testid = 'night-dots' }) {
  const { t, lang } = useI18n();
  const tz = policy.timezone;
  const nights = useMemo(() => lastNights(buckets || [], ids, policy), [buckets, ids, policy]);
  const [sel, setSel] = useState(0);
  const hm = (ms) => fmtInTz(ms, tz, { hour: '2-digit', minute: '2-digit' }, lang);
  const day = (ms) => fmtInTz(ms, tz, { weekday: 'short' }, lang);
  const night = nights[sel];
  const label = sel === 0 ? t('mvn_last_night') : `${fmtInTz(night.window.fromMs, tz, { weekday: 'short', day: 'numeric' }, lang)} → ${fmtInTz(night.window.toMs, tz, { weekday: 'short', day: 'numeric' }, lang)}`;

  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-7 gap-1 sm:gap-2 max-w-md">
        {[...nights].reverse().map((nt) => {
          const active = nt.offset === sel;
          return (
            <button key={nt.offset} type="button" onClick={() => setSel(nt.offset)} data-testid={`${testid}-dot-${nt.offset}`} data-kind={nt.kind}
              aria-pressed={active} aria-label={`${day(nt.window.fromMs)}: ${t(VERDICT_NAME[nt.kind])}`}
              className="flex flex-col items-center gap-1.5 group min-w-0">
              <span className="transition-transform duration-200 group-hover:scale-110"><VerdictDot kind={nt.kind} active={active} /></span>
              <span className={`text-[10px] truncate max-w-full ${active ? 'text-ink font-semibold' : 'text-ink-muted'}`}>{nt.offset === 0 ? t('mvn_last_short') : day(nt.window.fromMs)}</span>
            </button>
          );
        })}
      </div>
      <p className="text-sm text-ink mt-4 leading-relaxed" data-testid={`${testid}-sentence`}>
        <span className="font-semibold">{label}</span>
        <span className="text-ink-muted"> · {t(VERDICT_NAME[night.kind])}</span>
        <br />
        {nightSentence(t, night, hm)}
      </p>
    </div>
  );
}
